export default __webpack_public_path__ + "static/media/banner_1.c05ce2c9.jpg";